import { defineComponent as _defineComponent } from 'vue'
import useGetAccessToken from "@/use/useGetAccessToken";
import deviceHelper from "@/utils/deviceInfo";
import { KCPResult, SERVICE_UID } from "@/types";
import { IBookRequest } from "@/repositories/book/bookRepository.types";
import useGetProtocolHost from "@/use/useGetProtocolHost";
import useResizeWebviewWithSafeArea from "@/use/useResizeWebviewWithSafeArea";
// import { onMounted, onBeforeUnmount } from "vue";


const __default__ = {
  name: "BookKcp",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["onBookComplete"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

// kcp 결제
const kcpSubmit = (params: IBookRequest) => {
  const kcpForm = document.forms.namedItem("kcpForm") as HTMLFormElement;
  const baseUrl = `${useGetProtocolHost()}/aibos/client/api`;
  const contextPath = `${baseUrl}/${process.env.VUE_APP_API_VERSION}/service/${SERVICE_UID}/book-kcp`;
  kcpForm.target = deviceHelper.isMobile() ? "_self" : "kcpFrame";
  kcpForm.action = contextPath;
  kcpForm.jsonBody.value = JSON.stringify(params);
  kcpForm.submit();
  useResizeWebviewWithSafeArea(true);
};

// KCP PC 결제 완료시 백엔드에서 paymentResult 함수 호출
window.paymentResult = (result: KCPResult) => {
  emit("onBookComplete", result);
};

// // PC인 경우에만 paymentResult 호출됨
// const handlePaymentResult = (event: MessageEvent) => {
//   const trustedDomains = ["https://client-api.e-bus.co.kr"];
//   if (
//     trustedDomains.includes(event.origin) &&
//     event.data.method === "paymentResult"
//   ) {
//     const result = event.data.paymentData as KCPResult;
//     emit("onBookComplete", result);
//   }
// };

// onMounted(() => {
//   window.addEventListener("message", handlePaymentResult);
// });

// onBeforeUnmount(() => {
//   window.removeEventListener("message", handlePaymentResult);
// });

__expose({ kcpSubmit });

const __returned__ = { emit, kcpSubmit, get useGetAccessToken() { return useGetAccessToken } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})